import { PropsWithChildren, useCallback } from "react";
import { Box, Container, DialogContentText, Typography } from "@mui/material";
import OnboardingNavbar from "./OnboardingNavbar";
import { useDialogContext, postRoute } from "@WahooFitness/wahoo-offline-mfe";
import { Trans, t } from "@lingui/macro";

function OnboardingLayout({ children }: PropsWithChildren) {
  const { handleClose, setDialog } = useDialogContext();
  const openConfirmationDialog = useCallback(async () => {
    setDialog({
      open: true,
      title: t`Exit Setup?`,
      body: (
        <DialogContentText>
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="prose-base">
              <Trans>
                Are you sure you want to exit the KICKR RUN setup? Please complete the setup for an
                optimal experience and to receive <b>KEY SAFETY INSTRUCTIONS</b>. For your safety,
                key features of your KICKR RUN are disabled until setup is complete.
              </Trans>
            </Typography>
            <Typography variant="prose-base">
              <Trans>
                To continue setting up later, visit the KICKR Run page in the Devices tab.
              </Trans>
            </Typography>
          </Box>
        </DialogContentText>
      ),
      actions: [
        { text: t`Cancel`, action: handleClose },
        {
          text: t`Exit`,
          action: () => {
            postRoute("home");
            handleClose();
          },
        },
      ],
    });
  }, [handleClose, setDialog]);
  return (
    // Fixed height (not minHeight) so the flex column below has a definite height to
    // divide: a percentage height on the Box would otherwise resolve to auto and
    // collapse the chain that pins each page's action button to the bottom.
    // wf-self-scrolling-page suppresses the shell's page-end spacer, which would
    // otherwise add a second scroll region below the fixed page.
    <Container
      className="wf-self-scrolling-page"
      maxWidth="sm"
      disableGutters
      sx={{ height: "100%" }}
    >
      <Box
        id="onboarding-layout"
        display="flex"
        flexDirection="column"
        overflow="auto"
        height="100%"
        alignItems="center"
      >
        <OnboardingNavbar onClose={openConfirmationDialog} />
        {/* Takes the height left over by the navbar so each page's height: 100% resolves
            to the space it actually has. Sizing pages against the full layout height
            instead pushed their action buttons off-screen by the navbar's height. */}
        <Box flex={1} minHeight={0} width="100%" display="flex" flexDirection="column">
          {children}
        </Box>
      </Box>
    </Container>
  );
}

export default OnboardingLayout;
